export const Breakpoints = {
  2: 34,
  3: 25,
  4: 20,
  6: 12,
};
